import Typography from 'components/generics/texts/Typography';

const ProfileDocumentsEmpty = () => {
  return <Typography>No Documents Found</Typography>;
};

export default ProfileDocumentsEmpty;
